import { lazy } from "react";

export const CollaborationDetails = lazy(() => import("./CollaborationDetails"));
export const Collaboration = lazy(() => import("./Collaboration"));
